/****************************************************
 * Module Name:  labPricing.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useRef, useState } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip, Tabs, Tab, IconButton, Stack, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ApproveModal from "./approveModal";
import StoneDetailModal from "../common/stoneDetailModal";
import Constants from "../../utility/constants";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import CommonStoneSelection from "../common/commonStoneSelection";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import Papa from 'papaparse';
import { BackupTable } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import EditIcon from '@mui/icons-material/Edit';
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import PDFModal from "../common/pdfModal";
import { HiPrinter } from "react-icons/hi2";
import StickerPrintModal from "../common/stickerPrintModal";
import StoneMediaModal from "../common/stoneMediaModal";
import NivodaUtilityProxy from "../../utility/proxy/nivodautility/nivodautilityProxy";
import { FiRefreshCcw } from "react-icons/fi";
import PageTitle from "../common/pageTitle";
import { VscRunAll } from "react-icons/vsc";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";

const LabPricing = () => {
  const { apiRef } = Utility.useSingleClickEdit();
  const [listData, setListData] = useState([]);

  const [pricingLoader, setPricingLoader] = useState(false);

  const [isColumnsHidden, setIsColumnsHidden] = useState(true);

  const [selectedRowData, setSelectedRowData] = useState([]);

  const [selectionModel, setSelectionModel] = useState([]);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [alertSnackbar, setAlertSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successResponse, setSuccessResponse] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [uploadLoader, setUploadLoader] = useState(false);

  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  const [byte, setByte] = useState();
  const [showStickerModal, setShowStickerModal] = useState(false);

  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [refetchLoader, setRefetchLoader] = useState(false);

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_LAB_PRICING
    )
  );

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  const [tabValue, setTabValue] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [showNaturalTab, setShowNaturalTab] = useState(false);
  const [showLabGrownTab, setShowLabGrownTab] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [extraPacket, setExtraPacket] = useState([]);
  const extraPacketRef = useRef(extraPacket);

  useEffect(() => {
    extraPacketRef.current = extraPacket;
  }, [extraPacket]);

  // Create a connection
  const ws = useRef(null);

  const startScanning = () => {

    if (!ws.current) {
      ws.current = new WebSocket(Constants.RFID_API);

      ws.current.onerror = () => {
        setShowSnackbar(true);
        setSnackbarMessage(`RFID Machine not found. Please setup your RFID Machine and try again later.`);
        setSnackbarVariant("error");
        ws.current = null;
      }
    }

    // Open WebSocket connection and start scanning
    if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
      // WebSocket doesn't exist or was closed — create new one
      ws.current = new WebSocket(Constants.RFID_API);

      ws.current.onerror = () => {
        setShowSnackbar(true);
        setSnackbarMessage(`RFID Machine not found. Please setup your RFID Machine and try again later.`);
        setSnackbarVariant("error");
        ws.current = null;
      }

      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.CONNECTING) {
      // Still connecting — safely attach onopen
      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.OPEN) {
      // Already open — send immediately
      ws.current.send("START_SCAN");
    }

    // Listen for incoming messages from WebSocket
    let lstTags = new Set();
    ws.current.onmessage = (e) => {
      let message = typeof e.data === 'string' ? e.data : String(e.data);
      if (message.includes("TAG: ")) {
        const parts = message.split("TAG: ");
        if (parts.length === 2) {
          const remaining = parts[1].trim(); // remove extra whitespace
          remaining.split(',').forEach(str => lstTags.add(str.trim())); // split and trim each item
        }

        if (listData.length > 0) {
          setTagsSelections(lstTags);
        }
      } else if (message.includes("SCAN_COMPLETED")) {
        ws.current.close();
        ws.current.onclose = () => {
          getStoneIdByTagId();
        }
      }
    };
  }

  const setTagsSelections = (tags) => {
    //tags is array or string which are tag sample ['t1','t2']
    let lStockData = listData;
    let iNewSelected = 0;
    let iUnSelectedTags = 0;
    let selectedCheckBox = [];
    let tagsFound = [];
    let tagsNotFound = [];

    for (let loopCnt = 0; loopCnt < lStockData.length; loopCnt++) {
      if (lStockData[loopCnt].tag && tags.has(lStockData[loopCnt].tag)) {
        selectedCheckBox.push(lStockData[loopCnt].stoneid);
        tagsFound.push(lStockData[loopCnt].tag);
        iNewSelected++;
      }
    }

    tagsNotFound = [...tags].filter(tag => !tagsFound.includes(tag));
    iUnSelectedTags = tags.size - iNewSelected;

    setListData(() => {
      let selectedStone = [];
      let unSelectedStone = [];
      lStockData.forEach((res) => {
        if (selectedCheckBox.includes(res.stoneid)) {
          selectedStone.push(res);
        } else {
          unSelectedStone.push(res);
        }
      });
      return [...selectedStone, ...unSelectedStone];
    });
    setSelectionModel(selectedCheckBox);
    if (tagsNotFound.length > 0) {
      setExtraPacket(prev => Array.from(new Set([...prev, ...tagsNotFound])));
    }

    return {
      NewSelectedStones: iNewSelected,
      UnusedTags: iUnSelectedTags,
    };
  };

  const getStoneIdByTagId = () => {
    if (extraPacketRef.current.length > 0) {
      StoneProxy.GetStoneIdByTagId(extraPacketRef.current, (response) => {
        if (response) {
          let resultString = Object.entries(response)
            .map(([stoneid, tag]) => `${stoneid}: ${tag}`)
            .join(', ');

          if (Object.entries(response).length < extraPacketRef.current.length) {
            const usedTags = new Set(Object.values(response));
            const extraTags = extraPacketRef.current.filter(tag => !usedTags.has(tag));

            const extraTagString = extraTags.map(tag => `STONE_ID: ${tag}`).join(', ');
            resultString = resultString + ', ' + extraTagString;
          }

          setShowSnackbar(true);
          setSnackbarMessage(`You have ${resultString} extra package on your RF Machine`);
          setSnackbarVariant("error");
          setExtraPacket([]);
          ws.current = null;
        } else {
          setShowSnackbar(true);
          setSnackbarMessage(Constants.APiFailErrorMessage);
          setSnackbarVariant("error");
          ws.current = null;
          setExtraPacket([]);
        }
      })
    }
  }

  useEffect(() => {
    PageTitle("OPERATION_LAB_PRICING");
    let showNaturalTab = checkPermission("STONETYPE_NATURAL") || !checkPermission("STONETYPE_LABGROWN");
    setShowNaturalTab(showNaturalTab);
    setShowLabGrownTab(checkPermission("STONETYPE_LABGROWN"));
    setTabValue(checkPermission("STONETYPE_NATURAL") || !checkPermission("STONETYPE_LABGROWN") ? 0 : (checkPermission("STONETYPE_LABGROWN") && showNaturalTab ? 1 : 0));
    setActiveTab(checkPermission("STONETYPE_NATURAL") || !checkPermission("STONETYPE_LABGROWN") ? "Natural" : "Lab Grown");
  }, []);


  useEffect(() => {
    if (activeTab !== "")
      handleSearch(activeTab);
  }, [activeTab]);

  const checkPermission = (permission) => {
    return Utility.isReadAllowed(Constants.USER_PERMISSION.filter((iPermission) =>
      iPermission.permissionid === Constants.PERMISSIONS[permission]
    ));
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(event.target.textContent);
    setTabValue(newValue);
  };

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  const handleSearch = (activeTab) => {
    setPricingLoader(true);
    let stonetype = activeTab === "Natural" ? "N" : "L";
    LabTestProxy.GetAllPricingStones(stonetype, (response) => {
      if (response) {
        response = response.map((data) => {
          return { ...data, editedprice: data.colortype === "WHITE" ? data.discount : data.price, editedtotal: data.total };
        })

        const uniqueFilterValues = {
          labshape: Utility.getDistinctOptions(response, 'labshape'),
          distinctStatus: Utility.getDistinctOptions(response, 'status'),
        }

        try {
          response.map(iResponse => {
            if (iResponse.nivodaPriceList && iResponse.nivodaPriceList.priceList && iResponse.nivodaPriceList.priceList.length > 0) {
              iResponse.nivodaPriceList.priceList.forEach((iPriceList, index) => {
                iResponse[`${index + 1}`] =
                  iPriceList.discount + ' | ' + iPriceList.price + ' (' + iPriceList.noOfStones + ')';
              });
            }
            iResponse.iteration = iResponse.nivodaPriceList.iteration;
            return iResponse;
          });

        } catch (error) {
          console.error("Error processing response data:", error);
        }
        prepareColumns(uniqueFilterValues);
        setListData(response);
        loadTotalData(response);
        setPricingLoader(false);
      } else {
        setErrorSnackbar(true)
        setPricingLoader(false);
      }
    });
  };


  const handleApproveOpen = () => {

    let resultData = [];
    if (selectionModel.length > 0) {
      selectionModel.forEach(id => {
        listData.find(data => {
          if (data.stoneid === id) {
            resultData.push({
              stoneid: data.stoneid,
              price: data.price,
              total: data.total,
              discount: data.discount,
              userid: Constants.loggedInUser.id,
              status: "NEW",
              date: new Date().toISOString(),
            });
          }
          return false;
        })
      });
    }
    setSelectedRowData(resultData)
    setShowApproveModal(!showApproveModal);

  };

  const handleValidation = (data) => {
    //TODO do validation if needed here
    return true;
  };

  const handleApproveStones = (data) => {
    setLoading(true);
    setShowApproveModal(false);
    let stonetype = activeTab === "Natural" ? "N" : "L";
    LabTestProxy.AddPricing(data, stonetype, (responseData) => {
      if (responseData) {
        handleSearch(activeTab);
        setLoading(false);
        setIsColumnsHidden(true);
        setSelectedRowData([]);
        setSuccessResponse(true);
        setSuccessMessage("Pricing Added Successfully")
      } else {
        setLoading(false);
        setErrorSnackbar(true);
      }
    });
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
    setAlertSnackbar(false);
    setUploadSuccessSnackbar(false)
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const handleOnRefetchCriteria = () => {
    setRefetchLoader(true);
    let data = [];
    let invalidDataStoneIds = [];
    selectionModel.map((stoneid) => {
      const matchedRow = listData.find(data => data.stoneid === stoneid)
      if (matchedRow && matchedRow.colortype === "WHITE") {
        data.push({
          stoneid: String(matchedRow.stoneid),
          filtertype: "Similar or Better",
          priority: 1,
        })
      } else {
        invalidDataStoneIds.push(stoneid);
      }
      return true;
    })
    if (data.length > 0)
      RefetchCriteria(data);
    if (invalidDataStoneIds.length > 0) {
      setAlertMessage("Stone id(s) " + invalidDataStoneIds.join(", ") + " with FANCY colortype cannot be refetched.");
      setAlertSnackbar(true);
      setAlertVariant("info");
    }
    setRefetchLoader(false);
  }

  const RefetchCriteria = (criteriaList) => {
    NivodaUtilityProxy.RefetchCriteria(criteriaList, (response) => {
      if (response) {
        handleSearch(activeTab);
        setRefetchLoader(false);
        setSuccessResponse(true);
        setSuccessMessage("Criteria Refetched Successfully")
        setSelectionModel([]);
      }
      else {
        setRefetchLoader(false);
        setErrorSnackbar(true);
      }
    })
  }

  const handleUpload = (file) => {
    const reader = new FileReader();
    setUploadLoader(false);
    reader.onload = () => {
      const text = reader.result;
      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          if (result.data.length <= 0) {
            setAlertSnackbar(true);
            setAlertMessage("No Stones Found");
            setAlertVariant("error");
            return;
          }

          let headersFromCSV = Object.keys(result.data[0]);
          let requiredColumns = activeTab === "Natural" ? ['stoneid', 'newprice'] : ['stoneid', 'newtotal'];
          if (headersFromCSV.length === requiredColumns.length) {
            let matchedList = [];
            let unmatchedList = [];
            const stoneIdsInStockData = new Set();

            result.data.forEach(record => {
              listData.find(row => {
                if (activeTab === "Natural") {
                  if (row.stoneid === parseInt(record.stoneid) && (record['newprice'] !== null && record['newprice'] !== '')) {
                    if (row.colortype === "WHITE" && (-100 < parseFloat(record['newprice']) && parseFloat(record['newprice']) <= 1000)) {
                      row.editedprice = parseFloat(record['newprice']);
                      row.price = parseFloat(Number(row.rapnetprice * ((100 + parseFloat(row.editedprice)) / 100)).toFixed(2));
                      row.total = parseFloat((row.price * Number(row.size)).toFixed(2));
                      row.discount = row.editedprice;
                      matchedList.push(row);
                      stoneIdsInStockData.add(row.stoneid);
                    } else if (row.colortype === "FANCY" && (parseFloat(record['newprice']) > 0)) {
                      row.editedprice = parseFloat(record['newprice']);
                      row.price = row.editedprice;
                      row.total = parseFloat((row.price * Number(row.size)).toFixed(2));
                      row.discount = 0.00;
                      matchedList.push(row);
                      stoneIdsInStockData.add(row.stoneid);
                    }
                  }
                } else if (activeTab === "Lab Grown") {
                  if (row.stoneid === parseInt(record.stoneid) && (record['newtotal'] !== null && record['newtotal'] !== '')) {
                    if (row.colortype === "WHITE") {
                      row.editedtotal = parseFloat(record['newtotal']);
                      row.total = row.editedtotal;
                      row.price = parseFloat((row.total / Number(row.size)).toFixed(2));
                      row.discount = parseFloat((((row.price / row.rapnetprice) * 100) - 100).toFixed(2));
                      matchedList.push(row);
                      stoneIdsInStockData.add(row.stoneid);
                    } else if (row.colortype === "FANCY" && (parseFloat(record['newtotal']) > 0)) {
                      row.editedtotal = parseFloat(record['newtotal']);
                      row.total = row.editedtotal;
                      row.price = parseFloat((row.total / Number(row.size)).toFixed(2));
                      row.discount = 0.00;
                      matchedList.push(row);
                      stoneIdsInStockData.add(row.stoneid);
                    }
                  }
                }
                return false;
              });
              return true;
            });

            if (stoneIdsInStockData.size > 0) {
              setIsColumnsHidden(false);
              setDisableSubmit(false);
            }

            //to add unmatched stones down in the selection model
            listData.forEach(iRow => {
              if (!stoneIdsInStockData.has(iRow.stoneid)) {
                unmatchedList.push(iRow);
              }
            });

            setSelectionModel(Array.from(stoneIdsInStockData));
            setListData(matchedList.concat(unmatchedList));
            setUploadLoader(false);
            setUploadSuccessSnackbar(true);
          } else {
            console.error('CSV columns do not match table columns.');
            setUploadLoader(false);
            setUploadSuccessSnackbar(true);
          }
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
          setAlertSnackbar(true)
          setUploadLoader(false);
        }
      });
    };
    reader.readAsText(file);
  };

  const handleClear = () => {
    const fileInput = document.getElementById('file-input');
    fileInput.value = null;
  }

  const prepareColumns = (uniqueFilterValues) => {
    let columnNames = [];

    columnNames.push({
      field: "id",
      headerName: "BATCH ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    });

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        if (columnData.field === "status") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues.distinctStatus;
          columnData.filterOperators = Utility.combinedFilters();
        }
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
          })
        }
        if (columnData.field === "shape") {
          columnNames.push({
            field: "labshape",
            headerName: "LAB SHAPE",
            headerAlign: "center",
            align: "center",
            width: 90,
            renderCell: renderCellExpand,
            type: "singleSelect",
            valueOptions: uniqueFilterValues.labshape,
          })
        }
        if (columnData.field === "price") {
          columnNames.push({
            field: "newprice",
            headerName: "PPC / DIS",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 150,
            hideable: false,
            editable: true,
            preProcessEditCellProps: (params) => {
              return { ...params.props };
            },
            renderCell: (params) => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(params.row.editedprice)} {params.row.colortype === "WHITE" ? "(Dis)" : "(PPC)"}</span>
                {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: 1 }} />}
              </div>
            ),
            cellClassName: (params) => 'lavenderCell',
          },
            {
              field: "newtotal",
              headerName: "NEW TOTAL",
              headerAlign: "center",
              align: "right",
              type: "number",
              valueFormatter: (params) => params.value,
              width: 120,
              hideable: false,
              editable: true,
              preProcessEditCellProps: (params) => {
                return { ...params.props };
              },
              renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{Utility.ConvertNumberWithSpecifiedDigits(params.row.editedtotal)}</span>
                  {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: 1 }} />}
                </div>
              ),
              cellClassName: (params) => 'lavenderCell',
            }
          )
        }
        if (columnData.field === "total") {
          columnNames.push(
            ...Array.from({ length: 11 }, (_, index) => ({
              field: `${index + 1}`,
              headerName: `${index + 1}`,
              headerAlign: "center",
              align: "center",
              width: 110,
              renderCell: (params) => {
                return params.value
              },
            })),
            {
              field: "iteration",
              headerName: "DT FCH",
              headerAlign: "center",
              align: "center",
              width: 70,
              type: "date",
              valueGetter: (params) => {
                if (params.value) {
                  return new Date(params.value);
                }
                return null;
              },
              renderCell: (params) => {
                if (params.value) {
                  return Utility.ConvertUtcToLocalDate(params.value);
                } else {
                  return "";
                }
              }
            },
          );
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      width: 100,
      align: "center",
      renderCell: renderCellExpand,
      editable: true,
    },
    "c6161d51-13c0-479e-abe8-2a14b2d8b914": {
      field: "resultdate",
      headerName: "RESULT DATE",
      headerAlign: "center",
      width: 100,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      align: "center",
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 40,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 80,
      renderCell: renderCellExpand,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 50,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount),
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 65,
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COL DESCRIP",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 75,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 100,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "54fbd914-6ce7-44a8-9354-db6125ba1992": {
      field: "tag",
      headerName: "TAG",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
      field: "tableinc",
      headerName: "TABLE INC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
      field: "sideinc",
      headerName: "SIDE INC",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e993a4f7-7c50-4d83-abae-fccc03382742": {
      field: "h_and_a",
      headerName: "H&A",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
      field: "eyeclean",
      headerName: "EYE CLEAN",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
      field: "tinge",
      headerName: "TINGE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c95089ee-166d-4783-817c-2638f6d40df1": {
      field: "milky",
      headerName: "MILKY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
      field: "luster",
      headerName: "LUSTER",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
      field: "tableblack",
      headerName: "TABLE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
      field: "sideblack",
      headerName: "SIDE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },

  };

  const handleCellClick = (params) => {
    const { colDef, id, field } = params;
    if (colDef.editable)
      apiRef.current.startCellEditMode({ id, field });

    const allowedColumns = Array.from({ length: 11 }, (_, index) => `${index + 1}`);

    if (allowedColumns.includes(params.field) && params.value !== undefined && params.value !== null && params.value !== "") {
      let tempRows = listData.map(iData => {
        if (iData.stoneid === params.id) {
          iData.nivodaPriceList.priceList.forEach(iPriceList => {
            if (iPriceList.position === Number(params.field)) {
              if (iData.colortype === "WHITE") {
                if (activeTab === "Lab Grown") {
                  let total = iPriceList.price;
                  let price = parseFloat((total / Number(iData.size)).toFixed(2));
                  let discount = parseFloat((((price / iData.rapnetprice) * 100) - 100).toFixed(2));

                  if (discount != null && -100 < discount && discount <= 1000) {
                    iData.discount = discount;
                    iData.total = total;
                    iData.price = price;
                    iData.editedtotal = total;
                  }
                  else {
                    setAlertSnackbar(true);
                    setAlertMessage("Discount should be a between -100 to 1000");
                    setAlertVariant("error");
                    setDisableSubmit(true);
                  }
                } else if (activeTab === "Natural") {
                  if (iPriceList.discount != null && -100 < iPriceList.discount && iPriceList.discount <= 1000) {
                    iData.discount = iPriceList.discount;
                    iData.editedprice = iData.discount;
                    iData.price = parseFloat(Number(iData.rapnetprice * ((100 + parseFloat(iData.discount)) / 100)).toFixed(2));
                    iData.total = parseFloat((iData.price * Number(iData.size)).toFixed(2));
                  }
                  else {
                    setAlertSnackbar(true);
                    setAlertMessage("Discount should be a between -100 to 1000");
                    setAlertVariant("error");
                    setDisableSubmit(true);
                  }
                }
              }
              else if (iData.colortype === "FANCY") {
                iData.total = iPriceList.price;
                iData.price = parseFloat((iData.total / Number(iData.size)).toFixed(2));
                iData.editedprice = iData.price;
                iData.editedtotal = iData.total;
                iData.discount = 0.00;
              }
            }
          })
        }
        return iData;
      })
      setListData(tempRows);
    }
  }

  const handleProcessRowUpdateError = (error) => {
    // console.error(error);
  };

  const processRowUpdate = (newRow, oldRow) => {

    const changedFeilds = Utility.getChangedFields(newRow, oldRow);
    if (changedFeilds.length > 0) {
      const { id, value } = changedFeilds[0];

      let list = listData.map(data => {
        if (data.stoneid === id && (value !== undefined || value !== null)) {
          if (activeTab === "Natural") {
            if (data.colortype === "WHITE") {
              if (-100 < value && value <= 1000) {
                data.editedprice = value;
                data.price = parseFloat(Number(data.rapnetprice * ((100 + parseFloat(value)) / 100)).toFixed(2));
                data.total = parseFloat((data.price * Number(data.size)).toFixed(2));
                data.discount = value;
                setDisableSubmit(false);
              } else {
                data.editedprice = data.discount;
                setAlertSnackbar(true);
                setAlertMessage("Discount should be a between -100 to 1000");
                setAlertVariant("error");
                setDisableSubmit(true);
              }
            } else if (data.colortype === "FANCY") {
              if (value > 0) {
                data.editedprice = value;
                data.price = value;
                data.total = parseFloat((data.price * Number(data.size)).toFixed(2));
                data.discount = 0.00;
                setDisableSubmit(false);
              } else {
                data.editedprice = data.price;
                setAlertSnackbar(true);
                setAlertMessage("Price should be a postive number greater than 0");
                setAlertVariant("error");
                setDisableSubmit(true);
              }
            }
          } else if (activeTab === "Lab Grown") {
            if (data.colortype === "WHITE") {
              if (value > 0) {
                let total = value;
                let price = parseFloat((total / Number(data.size)).toFixed(2));
                let discount = parseFloat((((price / data.rapnetprice) * 100) - 100).toFixed(2));
                if (discount != null && -100 < discount && discount <= 1000) {
                  data.discount = discount;
                  data.editedtotal = total;
                  data.total = total;
                  data.price = price;
                  setDisableSubmit(false);
                } else {
                  data.editedtotal = data.total;
                  setAlertSnackbar(true);
                  setAlertMessage("Discount should be a between -100 to 1000");
                  setAlertVariant("error");
                  setDisableSubmit(true);
                }
              }
            }
            else if (data.colortype === "FANCY") {
              if (value > 0) {
                data.editedtotal = value;
                data.total = value;
                data.price = parseFloat((data.total / Number(data.size)).toFixed(2));
                data.discount = 0.00;
                setDisableSubmit(false);
              }
            }
          }
        }
        return data;
      });
      setListData(list);

      const updatedRow = list.find(row => row.stoneid === id);
      return updatedRow;
    } else {
      // No changes detected, return the newRow to trigger exit edit mode
      return { ...newRow };
    }

  };

  const columns = isColumnsHidden
    ? columnNames.filter((col) => col.field !== "newprice" && col.field !== "newtotal")
    : activeTab === "Natural" ? columnNames.filter((col) => col.field !== "newtotal")
      : columnNames.filter((col) => col.field !== "newprice");

  // Packet Print
  const printPacket = () => {
    let data = listData.filter(item => selectionModel.includes(item.stoneid));
    ReportProxy.GeneratePacketPrintPDF(data, response => {
      if (response) {
        setByte(response.fileBytes);
        openModal()
      }
    })
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
          px: 1,
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
          <CommonStoneSelection
            title={"Enter multiple Stone Ids"}
            handleSelection={handleSelection}
            buttonDisabled={listData.length === 0}
          />

          <Tooltip title={"Start Scan"}>
            <IconButton
              color="success"
              onClick={startScanning}
              disabled={listData.length === 0}
            >
              <VscRunAll />
            </IconButton>
          </Tooltip>

          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />

          {Utility.isAddAllowed(local_Permission) && (
            <>
              <Tooltip title={"Print Packet"}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1 }}
                  color="secondary"
                  startIcon={<HiPrinter size={14} />}
                  disabled={selectionModel.length === 0}
                  onClick={printPacket}
                >
                  Packet
                </Button>
              </Tooltip>

              <Tooltip title={"Print Sticker"}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ ml: 1 }}
                  color="secondary"
                  startIcon={<HiPrinter size={14} />}
                  onClick={() => setShowStickerModal(true)}
                >
                  Sticker
                </Button>
              </Tooltip>
            </>
          )}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
          {pricingLoader ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                onClick={() => handleSearch(activeTab)}
                color="primary"
                fontSize="medium"
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          <Tooltip title="Download Sample Lab pricing Upload">
            <a
              href={
                activeTab === "Natural"
                  ? "/demo_excel/SampleNaturalLabPricingUpload.csv"
                  : "/demo_excel/SampleLabGrownLabPricingUpload.csv"
              }
              download={
                activeTab === "Natural"
                  ? "SampleNaturalLabPricingUpload.csv"
                  : "SampleLabGrownLabPricingUpload.csv"
              }
              style={{ color: "red", margin: "0 8px" }}
            >
              <BackupTable size={25} />
            </a>
          </Tooltip>

          <Tooltip title="Upload Lab Pricing">
            <LoadingButton
              color="info"
              variant="outlined"
              size="small"
              component="label"
              loading={uploadLoader}
              loadingPosition="start"
              startIcon={<UploadFileIcon />}
            >
              Upload
              <input
                hidden
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                multiple
                type="file"
                onChange={(e) => handleUpload(e.target.files[0])}
                onClick={(e) => handleClear()}
              />
            </LoadingButton>
          </Tooltip>

          {Utility.isUpdateAllowed(local_Permission) && isColumnsHidden ? (
            <Tooltip title="Add Price">
              <Button
                variant="outlined"
                size="small"
                sx={{ mx: 1 }}
                startIcon={<AddBoxOutlinedIcon />}
                disabled={selectionModel.length < 1}
                onClick={() => setIsColumnsHidden(false)}
              >
                Price
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title="Submit Stones">
              <LoadingButton
                variant="outlined"
                size="small"
                sx={{ mx: 1 }}
                startIcon={<ThumbUpAltIcon />}
                disabled={selectionModel.length === 0 || disableSubmit}
                onClick={handleApproveOpen}
                loading={loading}
                loadingPosition="start"
                type="submit"
              >
                Submit
              </LoadingButton>
            </Tooltip>
          )}

          <Tooltip title="Refetch Criteria">
            <LoadingButton
              variant="outlined"
              size="small"
              onClick={handleOnRefetchCriteria}
              disabled={selectionModel.length < 1}
              loading={refetchLoader}
              loadingPosition="start"
              startIcon={<FiRefreshCcw size={16} />}
            >
              Refetch
            </LoadingButton>
          </Tooltip>

          <GridToolbarQuickFilter debounceMs={500} />
        </Box>

        {showApproveModal && (
          <ApproveModal
            show={showApproveModal}
            setShow={setShowApproveModal}
            handleValidation={handleValidation}
            handleSave={handleApproveStones}
            stoneId={selectionModel}
            selectedFilledData={selectedRowData}
            sourceData={listData}
            type={"price"}
          />
        )}
      </GridToolbarContainer>
    );
  };


  return (
    <div>

      {/*need to send pdf in byte string to modal */}
      <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={byte} pdfName={"packetPrint"} />

      {listData ? (
        <TabMenuSnackbar
          show={uploadSuccessSnackbar}
          message={
            listData.length !== 0
              ? (selectionModel.length <= 0 ? `Please correct your data and retry again` : `File loaded Successfully`)
              : `File could not be loaded. Please correct your data and retry again`
          }
          variant={listData.length !== 0 && selectionModel.length > 0 ? "success" : "error"}
          autoHide={true}
          title={listData.length !== 0 && selectionModel.length > 0 ? "Success" : "Failed"}
          handleClose={handleClose}
        />
      ) : null}
      {successResponse ? (
        <TabMenuSnackbar
          show={successResponse}
          message={successMessage}
          variant={"success"}
          autoHide={true}
          title={"Success"}
          handleClose={() => setSuccessResponse(false)}
        />
      ) : null}

      <TabMenuSnackbar
        show={showSnackbar}
        message={snackbarMessage}
        variant={snackbarVariant}
        autoHide={Constants.SnackBarCloseTimer}
        title={snackbarVariant === "success" ? "Success" : snackbarVariant === "error" ? "Error" : "Warning"}
        handleClose={() => setShowSnackbar(false)}
      />

      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={() => setShowStoneMediaModal(false)}
          />
        </>
      ) : null}

      {showStickerModal ? (
        <StickerPrintModal
          show={showStickerModal}
          stoneIds={selectionModel}
          handleClose={() => setShowStickerModal(false)}
        />
      ) : null}

      <TabMenuSnackbar
        show={alertSnackbar}
        message={alertMessage}
        variant={alertVariant}
        autoHide={false}
        title={"Error"}
        handleClose={handleClose}
      />

      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />

      <Box m={1} sx={{ display: "flex", }}>
        <Box
          sx={{
            display: "flex",

            "& .MuiTabs-flexContainer": {
              marginLeft: "15px",
              marginTop: "0px",
            },
          }}
        >
          {showNaturalTab && showLabGrownTab && (
            <Tabs value={tabValue} onChange={handleTabChange} sx={{
              "& .MuiTabs-indicator": {
                height: "3px",
                bottom: "5px"
              },
              "& .MuiTabs-flexContainer": {
                marginLeft: "15px",
                marginTop: "3px"
              }
            }}>
              <Tab label="Natural" />
              <Tab label="Lab Grown" />
            </Tabs>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            flexBasis: 0,
            overflow: "hidden",
            color: "black",
            fontWeight: "normal",
            px: 1,
            textAlign: "center",
            paddingTop: "5px"
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            useFlexGap
            flexWrap="wrap"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              justifyContent: "center",
            }}
          >
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              No of Stones: <b>{noOfSelectedStones}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Total Weight: <b>{selectedTotalSize}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Total Price: <b>{selectedtotalPrice}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Avg Price: <b>{selectedavgPrice}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Avg Discount: <b>{selectedAvgDiscount}</b>
            </Typography>
          </Stack>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: "100%",
          position: "relative",
          "& .MuiTablePagination-selectLabel": {
            marginTop: "15px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "15px",
          },
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .css-cc8tf1": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .lavenderCell": {
            color: "#080808",
            backgroundColor: "#D8BFD8",
          },
          height: "70vh",
        }}
      >
        <DataGridPro
          disableRowSelectionOnClick={true}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              color: '#fff',
              backgroundColor: 'grey',
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "4px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "12px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "18px",
            },
            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
          }}
          density="compact"
          loading={pricingLoader}
          processRowUpdate={processRowUpdate}
          onProcessRowUpdateError={handleProcessRowUpdateError}
          onCellEditStart={() => setDisableSubmit(true)}
          slots={{ toolbar: CustomToolbar }}
          rows={listData}
          columns={columns}
          getRowId={(row) => row.stoneid}
          checkboxSelection={true}
          onRowSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
            setDisableSubmit(newSelectionModel.length > 0 ? false : true);
          }}
          rowSelectionModel={selectionModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns id, the other columns will remain visible
                status: false,
                approved: false,
                rejected: false,
                nextstate: false,
                remark: false,
                lab: false,
                locationid: false,
                cutpolsym: false,
                height: false,
                crownheight: false,
                crownangle: false,
                culetsize: false,
                culetcondition: false,
                gridlemin: false,
                intensitylongtitle: false,
                note: false,
                gridlecondition: false,
                gridlepercent: false,
                pavilionangle: false,
                paviliondepth: false,
                white: false,
                laserinscription: false,
                country: false,
                quality: false,
                labname: false,
                location: false,
                stonelabdetailstatus: false,
                suratid: false
              },
            },
            sorting: {
              sortModel: [{ field: "stoneid", sort: "asc" }],
            },
            pagination: {
              paginationModel: Constants.pageSize,
            },
          }}
          pageSizeOptions={Constants.pageSizeOptions}
          pagination
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          apiRef={apiRef}
          onCellClick={handleCellClick}
          editMode="cell"
        />
      </Box>
    </div>
  );
};

export default LabPricing;
